import { render, staticRenderFns } from "./ProductsTitle.vue?vue&type=template&id=91b0270e&scoped=true"
import script from "./ProductsTitle.vue?vue&type=script&lang=js"
export * from "./ProductsTitle.vue?vue&type=script&lang=js"
import style0 from "./ProductsTitle.vue?vue&type=style&index=0&id=91b0270e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b0270e",
  null
  
)

export default component.exports